const ChevronDownIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M7.00833 11.0938L12.0167 6.08542L10.8392 4.90625L7.00833 8.73958L3.17833 4.90625L2 6.08458L7.00833 11.0938Z"
          fill="#1F384C"
        />
      </g>
    </svg>
  );
};

export default ChevronDownIcon;
